// Entry changes affect Home totals, feed cards, and discovery, regardless of the hobby view that made them.
const HOME_ENTRY_MUTATIONS = new Set([
  'AddRecipe', 'UpdateRecipe', 'DeleteRecipe', 'ImportRecipe',
  'StartCookingSession', 'UpdateCookingSession', 'FinishCookingSession', 'DiscardCookingSession', 'LogPastCookingSession',
  'AddMovie', 'UpdateMovie', 'DeleteMovie', 'ImportLetterboxdMovies',
  'AddTVShow', 'UpdateTVShow', 'DeleteTVShow', 'SetTVEpisodeWatched',
  'AddBook', 'UpdateBook', 'DeleteBook', 'UpdateBookProgress', 'ImportGoodreadsBooks',
  'AddTrip', 'UpdateTrip', 'DeleteTrip', 'AddHike', 'UpdateHike', 'DeleteHike',
  'AddFitnessWorkout', 'UpdateFitnessWorkout', 'DeleteFitnessWorkout',
  'AddFitnessPlan', 'UpdateFitnessPlan', 'DeleteFitnessPlan',
  'StartFitnessWorkout', 'LogFitnessRoutineWorkout', 'UpdateFitnessWorkoutSession',
  'FinishFitnessWorkout', 'DiscardFitnessWorkout',
  'SaveMusicMoment', 'DeleteMusicMoment', 'UploadMusicRecording', 'RemoveMusicRecording',
  'SaveCreativeProject', 'DeleteCreativeProject',
  'SaveDiningPlace', 'SaveDiningVisit', 'DeleteDiningPlace', 'DeleteDiningVisit',
  'UploadEntryCoverPhoto', 'RemoveEntryCoverPhoto',
]);

/** Returns whether a successful mutation changed data used by Home. */
export function shouldInvalidateHome(operationName, result) {
  return HOME_ENTRY_MUTATIONS.has(operationName) && Boolean(result?.data) && !result.errors?.length;
}

/** Discards derived Home queries so the next visit fetches a fresh summary. */
export function invalidateHomeQueries(cache) {
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'getHomeSummary' });
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'getHomeFeedPage' });
  cache.gc();
}
